module.exports = __webpack_public_path__ + "img/hands-holding-using-magic-pen-on-tablet.93e3e16d.jpg";